import { Transaction } from '@heliofi/common';
import { ApiAdapter } from '../ApiAdapter';

export class TransactionSDK {
  private readonly apiAdapter: ApiAdapter;

  constructor(apiAdapter: ApiAdapter) {
    this.apiAdapter = apiAdapter;
  }

  async getTransaction(transactionSignature: string): Promise<Transaction> {
    return this.apiAdapter.get(
      `/transactions/signature/${transactionSignature}`,
      'Failed to get transaction',
    );
  }

  async getDepositTransaction(
    depositId: string,
    from?: string,
    to?: string,
    senderPK?: string,
  ): Promise<Transaction> {
    return this.apiAdapter.get(
      `/transactions/deposit/${depositId}/transactions`,
      'Failed to get deposit transactions',
      this.getParams(from, to, senderPK),
    );
  }

  async getDepositTransactionsByCustomerToken(
    customerToken: string,
    from?: string,
    to?: string,
    senderPK?: string,
  ): Promise<Transaction> {
    return this.apiAdapter.get(
      `/transactions/deposit/customer/${customerToken}/transactions`,
      'Failed to get deposit transactions by customer token',
      this.getParams(from, to, senderPK),
    );
  }

  private getParams(
    from?: string,
    to?: string,
    senderPK?: string,
  ): Record<string, string> {
    const params: Record<string, string> = {};

    if (from) params.from = from;
    if (to) params.to = to;
    if (senderPK) params.senderPK = senderPK;

    return params;
  }
}
